import React, { useEffect, useState } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const SimilarCard = ({
  villadata,
  location,
  adults,
  children,
  startDate,
  endDate,
  landmark,
}) => {
  const navigate = useNavigate();
  const handleCardClick = (villaId, villaName) => {
    const formData = {
      villaId: villaId,
      villaName: villaName,
      adults: adults,
      children: children,
      startDate: startDate,
      endDate: endDate,
      location: location,
    };

    const hyphenatedVillaName = villaName.replace(/\s+/g, '-');
    navigate(`/villa/${villaId}/${hyphenatedVillaName}`, { state: formData })
    window.location.reload();
  };

  const slidesdummy = [
    {
      source:
        "https://img.freepik.com/free-vector/glitch-error-404-page_23-2148105404.jpg",
    },
  ];

  const [slides, setSlide] = useState(slidesdummy);
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  const handleimages = () => {
    if (villadata.media_order.length > 0) {
      villadata.media.sort((a, b) => {
        const indexA = villadata.media_order.indexOf(a.media.id);
        const indexB = villadata.media_order.indexOf(b.media.id);
        return indexA - indexB;
      });
    }

    if (villadata.media.length > 0) {
      const newArray = villadata.media.map((item) => {
        return {
          source: item.media.file,
        };
      });
      // //console.log(villadata, "newArrayayaya");
      setSlide(newArray);
    }
  };

  useEffect(() => {
    handleimages();
  }, [villadata]);

  return (
    <div className="bg-white rounded-lg  h-[54vh] w-[380px] overflow-hidden shadow-lg p-2">
      <div className="relative w-full    h-3/5">
        {/* {villadata.media.length>0 ? (<img className="absolute w-full h-full object-cover" src={villadata.media[0].media.file} alt={villadata.property_name} />):(<img className="absolute w-full h-full object-cover" src="https://img.freepik.com/free-vector/glitch-error-404-page_23-2148105404.jpg" alt={villadata.property_name} />)} */}

        <div
          style={{
            backgroundImage: `url(${slides[currentIndex].source})`,
          }}
          className="w-auto h-full  bg-center bg-cover duration-400"
        ></div>
        {/* Left Arrow */}
        <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
          <BsChevronCompactLeft onClick={prevSlide} size={30} />
        </div>
        {/* Right Arrow */}
        <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
          <BsChevronCompactRight onClick={nextSlide} size={30} />
        </div>
      </div>
      <div className="p-4 flex flex-col h-2/5 justify-between ">
        <div>
          <div className="flex items-center justify-between">
            <h2
              className="text-lg font-semibold hover:cursor-pointer hover:underline"
              onClick={() => {
                handleCardClick(
                  villadata.property_ptr_id,
                  villadata.property_name
                );
              }}
            >
              {villadata.property_name}
            </h2>
            <div className="bg-gray-200 rounded-lg py-1 px-2">
              <span className="text-sm font-semibold">
                {villadata.a2z_score ? villadata.a2z_score : 0}
              </span>
            </div>
          </div>
          <p className="text-gray-600 text-sm mb-2 max-w-[70%]">
            {villadata.addressData?.area}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-gray-600 text-sm font-semibold">{landmark}</p>
          <p className="text-gray-700 text font-semibold">
            ₹{villadata.price_guest_pay} per Day/-
          </p>
        </div>
      </div>
    </div>
  );
};

export default SimilarCard;
